import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class ClientFirststartGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): UrlTree {
    const isFrv = environment.client === 'french-rendez-vous';
    const target = isFrv ? route.data['frvRoute'] : route.data['wfRoute'];
    // Preserve any matrix URL params (e.g. _fid, _country, ia) passed to the
    // dispatcher route so the target component receives them unchanged.
    const params = route.params;
    const hasParams = Object.keys(params).length > 0;
    return hasParams
      ? this.router.createUrlTree([target, params])
      : this.router.createUrlTree([target]);
  }
}
